export default class SetService {
    static union(a, b) {
        const _union = new Set(a);
        for (const elem of b) {
            _union.add(elem);
        }
        return _union;
    }
    static unionArray(a, b, areEqual) {
        // @ts-expect-error - TS2322 - Type 'A[]' is not assignable to type 'A | B[]'.
        return a.concat(
        // @ts-expect-error - TS2769 - No overload matches this call.
        b.filter((bItem) => !a.some((aItem) => areEqual(aItem, bItem))));
    }
    static intersection(a, b) {
        const _intersection = new Set();
        for (const elem of b) {
            if (a.has(elem)) {
                _intersection.add(elem);
            }
        }
        return _intersection;
    }
}
